import { BaseModel } from "@blue-chip/core";
import PermissionGroup from "./PermissionGroup";

export default class Permission extends BaseModel {
  static plural = "permissions";
  static get belongsTo() {
    return [PermissionGroup];
  }
}
